/* eslint-disable import/no-duplicates */
import React from "react";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";

export const COLUMN_DEF = {
    lockPosition: true,
    suppressMenu: true,
    suppressColumnsToolPanel: true,
    suppressMovable: true,
    resizable: true,
    filter: true,
};

interface IGridProps<T> extends AgGridReactProps {
    gridClassname?: string;
    rowData: T[];
}

type GridComponent<T = any> = React.FunctionComponent<IGridProps<T>>;

export const Grid: GridComponent = ({ gridClassname, rowData, defaultColDef = COLUMN_DEF, columnDefs, ...props }) => {
    return (
        <div className={`ag-theme-material ${gridClassname}`}>
            <AgGridReact
                rowData={rowData}
                defaultColDef={defaultColDef}
                columnDefs={columnDefs}
                debug={false}
                {...props}
            />
        </div>
    );
};
